module.exports = __webpack_public_path__ + "img/573.d1a859f5.jpg";